import React, {useState} from 'react';
import { Form, Button  } from 'antd';
import { CompanySlider } from './CompanySlider';
import CompanyInput from './CompanyInput';
import ClearFilters from './ClearFilters';



const CompanyForm = ({searchHandler, searchParams, clearParams}) => {

  const [sliderValue, setSliderValue] = useState()

  const sliderHandler = (sliderValue) =>
  { 
    setSliderValue(sliderValue)
  }

  const onFinish = (values) => {
    console.log('Success:', values, sliderValue);
    const searchingParams = {
      title: values.title,
      sliderValue,
    }
    searchHandler(searchingParams)
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
  <>
    <Form
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}
      style={{
          maxWidth: '100%',
          backgroundColor: '#FAFAFA',
          marginBottom: '10px',
          display: 'flex',
          justifyContent: "space-around",
          alignItems: "center", 
          gap:'30px',
          padding:'10px',
          borderRadius:'10px',
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
  
      <CompanyInput/>
      <CompanySlider sliderHandler={sliderHandler}/>
      
      <Button type="primary" htmlType="submit" style={{width:'200px'}}>
        Szukaj
      </Button>

  
    </Form>
    {(searchParams.title || searchParams.sliderValue!=='') && <ClearFilters activeFilters={searchParams} clearFilters={clearParams}/>}

  </>
  )
};
export default CompanyForm;